<template>
<div id="countdowntimer">
    <div id = "back2taskmanage">
    <a href="/taskmanager">back</a>
    </div>
  
    {{ timershowstring }}
</div>
</template>

<script>

    export default {

        data() {
            return {
                timerEnabled: true,
                timerCount: 1200,
                timershowstring:""
            }
        },

        watch: {

            timerEnabled(value) {
                if (value) {
                    setTimeout(() => {
                        this.timerCount--;
                        this.timershowstring = this.timerCount.toString()+"s"
                        if(this.timerCount==0){
                            this.timershowstring = "休息一下"
                        }
                    }, 1000);
                }
            },

            timerCount: {
                handler(value) {

                    if (value > 0 && this.timerEnabled) {
                        setTimeout(() => {
                            this.timerCount--;
                            this.timershowstring = this.timerCount.toString()+"s"
                        if(this.timerCount==0){
                            this.timershowstring = "休息一下"
                        }
                        }, 1000);
                    }

                },
                immediate: true // This ensures the watcher is triggered upon creation
            }

        },
        methods: {

            play() {
                this.timerEnabled = true;
            },

            pause() {
                this.timerEnabled = false;
            }

        }

    }

</script>

<style scoped>
#countdowntimer {
    color:red;
    position:absolute;
    left:40%;
    top:40%;
    font-size: 5.123em;
    
}

/* #back2taskmanage{
    position: absolute;
    left:10%;
} */

html{
    background:black;
}

</style>